export const isTestEnv = window._env_?.ENV === "test" || import.meta.env.NODE_ENV === "test";
export const isLocalEnv = window._env_?.ENV === "local";
export const isProductionEnv = window._env_?.ENV === "production";
